import { VideoPlayerButtonEmbedded } from '../web-components/video-player-button-embedded';